import { initialRootState } from '../initialRootState';
import {
  EAsyncActionTypes,
  TAsyncActionTypes,
  TAsynchronousState,
} from './types';

// TODO use immer instead of destructuring
export const asynchronousStateReducer = (
  state: TAsynchronousState = initialRootState.asynchronousState,
  action: TAsyncActionTypes
): TAsynchronousState => {
  switch (action.type) {
    case EAsyncActionTypes.ADD_ERROR:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          // TODO do not add error from payload but compute error code first
          error: {
            ...action.payload.error,
          },
        },
      };
    case EAsyncActionTypes.REMOVE_ERROR:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          error: undefined,
        },
      };
    case EAsyncActionTypes.SHOW_LOADER:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          isLoading: true,
        },
      };
    case EAsyncActionTypes.HIDE_LOADER:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          isLoading: false,
        },
      };
    case EAsyncActionTypes.SHOW_TOASTER:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          shouldShowToaster: true,
        },
      };
    case EAsyncActionTypes.HIDE_TOASTER:
      return {
        ...state,
        [action.payload.asyncEventName]: {
          ...state[action.payload.asyncEventName],
          shouldShowToaster: undefined,
        },
      };
    default:
      return state;
  }
};
